import React, { ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@interfaces/rootState';
import { SurgeryRequestGet } from '@interfaces/SurgeryRequest/SurgeryRequestGet';
import { CaseDetailsInfoSelector } from '@store/selectors/CaseDetailsSelector';
import { approvePendingCancellation } from '@store/actions/CancellationAlertsActionCreators';
import useHasPermission from '@utilities/hooks/useHasPermission/useHasPermission';
import { PermittedAction } from '@utilities/PermittedAction';
import { UserAccessEnum } from '@interfaces/SurgeryRequest/UserAccessEnum';
import useGetAccessor from '@components/CaseDetails/CaseInUse/hooks/useGetAccessor/useGetAccessor';
import { defaultCallback } from '@utilities/defaultCallback';
import TextLink from '@components/TextLink/TextLink';
import { CommonCancellationAlertBody } from '@components/Alerts/NotificationAlert/CommonCancellationAlertBody/CommonCancellationAlertBody';

export const PendingCancellationAlertBody = () => {
	const { isAccessorDifferentUser: caseInUse } = useGetAccessor([UserAccessEnum.CONFIRMER]);
	const dispatch = useDispatch();
	const hasCancelCasePermission = useHasPermission(PermittedAction.CONFIRM_CANCEL_CASE);

	const { id } = useSelector(
		CaseDetailsInfoSelector as (state: RootState) => SurgeryRequestGet
	);

	const handleResolved = React.useCallback(() => {
		dispatch(approvePendingCancellation(id));
	}, [dispatch, id]);

	const links: ReactNode | ReactNode[] = hasCancelCasePermission && (
		<TextLink disabled={caseInUse} onClick={caseInUse ? defaultCallback : handleResolved}>
			Confirm
		</TextLink>
	);

	return (
		<CommonCancellationAlertBody
			links={links}
			message="Requested to cancel the procedure."
		/>
	);
};
